import { useState } from "react";
import { ExclamationTriangleIcon } from "../../../../assets/icons/index.js";
import FormField from "../../../FormField/FormField.js";
import Provenienze from "../../../Provenienze";
import Repertori from "../../../Repertori";
import repertoStructure from "../../../../constants/dataStructure/reperto.json";
import GroupsFormField from "../../../GroupsFormField";
import CollocazioneSection from "../../EditReperto/CollocazioneSection/CollocazioneSection.jsx";
import CustomSelect from "../../../Common/CustomSelect/CustomSelect.jsx";
import ClassList from "../../../../assets/json/classi-materiali-flat.json";
import ImageGallery from "../../../ImageGallery/ImageGallery";
import AnnotazioniSection from "../../../Common/AnnotazioniSection/AnnotazioniSection";
import "./block-order.scss";

export default function RepertiRecordDetailForm({
  data,
  setData,
  onRaccoltaChange,
  disabled,
  immagini,
  handleImageChange,
  issues,
  showIssues,
}) {
  //const [cassettaId, setCassettaId] = useState("");
  //const navigate = useNavigate(); // Use useNavigate hook
  //const location = useLocation();
  const [iccdOpen, setIccdOpen] = useState(false);


  const handleFieldChange = (key, newValue) => {
    setData((prevData) => ({
      ...prevData,
      [key]: newValue,
    }));
  };

  // console.log("RepertiRecordDetailForm", disabled, issues, showIssues);
  return (
    <>
      <main className="reperti-main-container">
        <div className="content-wrapper">
          <div className="issue-container">
            {!disabled &&
              showIssues &&
              issues.map((issue, index) => {
                return (
                  <div key={index} className="issue">
                    <p className="issue-icon">
                      <ExclamationTriangleIcon />
                    </p>
                    {issue}
                  </div>
                );
              })}
          </div>
          <div className="blocks-container">
            <div className="form-block" id="add-reperto-generalità">
              <p className="section-title"> GENERALITÀ</p>
              <GroupsFormField
                groups={data?.groups || []}
                onChange={(newValue) => handleFieldChange("groups", newValue)}
                edit={true}
              />
              <Repertori
                repertori={data["codiciInventario"]}
                onChange={(newValue) =>
                  handleFieldChange("codiciInventario", newValue)
                }
                edit={true}
              />
            </div>
            <div className="form-block" id="add-reperto-provenienza">
              <p className="section-title"> PROVENIENZA</p>
              <FormField
                fieldStructure={repertoStructure["anno"]}
                value={data["anno"]}
                // value={data["anno"] ? data["anno"].value : ""}
                onChange={(newValue) => handleFieldChange("anno", newValue)}
                disabled={false}
              />
              <Provenienze
                provenienze={data["provenienze"]}
                onChange={(newValue) =>
                  handleFieldChange("provenienze", newValue)
                }
                edit={true}
              />
            </div>
            <div className="form-block" id="add-reperto-galleria">
              <p className="section-title"> GALLERIA IMMAGINI</p>
              <ImageGallery
                disabled={false}
                immagini={immagini}
                handleImageChange={handleImageChange}
              />
            </div>
            <div className="form-block" id="add-reperto-caratteristiche">
              <div className="blockHeader">
                <p className="section-title"> CARATTERISTICHE</p>
              </div>
              <FormField
                fieldStructure={repertoStructure["descrizione"]}
                //value={data["materiale"] ? data["materiale"].value : ""}
                value={data["descrizione"]}
                onChange={(newValue) =>
                  handleFieldChange("descrizione", newValue)
                }
                disabled={false}
              />
              <FormField
                fieldStructure={repertoStructure["materia"]}
                //value={data["materiale"] ? data["materiale"].value : ""}
                value={data["materiale"]}
                onChange={(newValue) =>
                  handleFieldChange("materiale", newValue)
                }
                disabled={false}
              />
              <CustomSelect
                options={ClassList.map(item => ({ label: `${item.description} (${item.value})`, value: item.value })).sort((a, b) => a.label.localeCompare(b.label))}
                initValue={data["classe"] ? data["classe"] : { label: "", value: "" }}
                name="classe"
                label={"Classe"}
                disabled={false}
                placeholder={data["classe"] ? ClassList.find(item => item.value === data["classe"]).description : "Seleziona classe"}
                onChange={(field, newValue) => handleFieldChange(field, newValue.value)}
              />
              <FormField
                fieldStructure={repertoStructure["forma"]}
                //value={data["forma"] ? data["forma"].value : ""}
                value={data["forma"]}
                onChange={(newValue) => handleFieldChange("forma", newValue)}
                disabled={false}
              />
              <FormField
                fieldStructure={repertoStructure["tipo"]}
                //value={data["tipo"] ? data["tipo"].value : ""}
                value={data["tipo"]}
                onChange={(newValue) => handleFieldChange("tipo", newValue)}
                disabled={false}
              />
              <FormField
                fieldStructure={repertoStructure["cronologia"]}
                //value={data["cronologia"] ? data["cronologia"].value : ""}
                value={data["cronologia"]?.description || ''}
                onChange={(newValue) =>
                  handleFieldChange("cronologia", { description: newValue })
                }
                disabled={false}
              />
              <FormField
                fieldStructure={repertoStructure["misure"]}
                //value={data["materiale"] ? data["materiale"].value : ""}
                value={data["misure"]}
                onChange={(newValue) =>
                  handleFieldChange("misure", newValue)
                }
                disabled={false}
              />
            </div>
            <div className="form-block" id="add-reperto-collocazione">
              <CollocazioneSection
                repertoData={data}
                disabled={false}
                handleFieldChange={handleFieldChange}
              />
            </div>
            <AnnotazioniSection
              annotazioni={data?.annotazioni}
              onChange={(newAnnotazioni) =>
                handleFieldChange("annotazioni", newAnnotazioni)
              }
              disabled={disabled}
              id="add-reperto-annotazioni"
            />
          </div>
        </div>
      </main>
    </>
  );
}
